import { render } from "./audio-player.vue?vue&type=template&id=34ccfaa0&scoped=true"
import script from "./audio-player.vue?vue&type=script&lang=js"
export * from "./audio-player.vue?vue&type=script&lang=js"

import "./audio-player.vue?vue&type=style&index=0&id=34ccfaa0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ccfaa0"]])

export default __exports__